import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import {
  ButtonContain,
  Card,
  CardContain,
  CardCustomList,
  CardFooter,
  CardTitle,
  CustomButtonContain,
  CustomButtonContainMoM,
  CardFooterMoM,
  TableContain,
  TabsContain,
} from "../../style/Home";
import Grid from "@mui/material/Grid";
import Filter from "../../Components/filters";
import DoughnutChart from "../../Components/AM/charts/Chart";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Colors } from "../../style/theme";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDropdownData } from "../../features/filterParameterSlice";
import { getCurrentFinancialYear, getCurrentMonth } from "../../utils/helper";
import { GetDashboardData } from "../../services/dashboardService";
import { resetFilter } from "../../features/filterSlice";
import { toast, ToastContainer } from "react-toastify";
import { Loader } from "../../utils/loader";
import ScoreHistoryModal from "../../Components/Modal/ScoreHistoryModal";
import PopUpModal from "../../Components/Modal/PopUpModal";
import moment from "moment";
import { UserPopUpNotification } from "../../services/popUpService";

function Home() {
  const [value, setValue] = useState("MVRTabs");
  const [isSticky, setIsSticky] = useState(false); // To track scroll position
  const [filterValues, setFilterValues] = useState({});
  const [dashboardData, setDashboardData] = useState({});
  const [loader, setLoader] = useState(false);
  const filtersValue = useSelector((state) => state.filterData);
  const [resetTrigger, setResetTrigger] = useState(Date.now());
  const dispatch = useDispatch();
  const [isDispatched, setIsDispatched] = useState(false);
  // popUp Work
  const [isPopupModalOpen, setIsPopupModalOpen] = useState(false);
  const [popUpData, setPopUpData] = useState([]);

  const closePopupModal = () => {
    setIsPopupModalOpen(false);
  };

  const fetchPopUpData = async () => {
    try {
      const response = await UserPopUpNotification();
      if (response.success) {

        const currentStamp = moment().format('YYYY-MM-DD HH:mm:ss');
        localStorage.setItem("lastPopUpAt", currentStamp)

        const notificationArray = response?.data?.notifications ?? [] 

        if(!notificationArray.length) return;

        setPopUpData(notificationArray);
        setIsPopupModalOpen(true)
        
      }
    } catch (error) {
      console.log("Error Fetching Data",error);
      toast.error('Network Error');
    }
    // finally{
    // }
  };

  useEffect(() => {
    const lastPopUpAt = localStorage.getItem("lastPopUpAt");

    if (!lastPopUpAt) {
      fetchPopUpData();
      return;
    }

    const lastPopUpAtStamp = moment(lastPopUpAt, "YYYY-MM-DD HH:mm:ss");
    const currentStamp = moment();
    const hoursDifference = currentStamp.diff(lastPopUpAtStamp, "minutes");

    if (hoursDifference < 180) return;

    fetchPopUpData();
  }, []);

  useEffect(() => {
    dispatch(resetFilter());
    setIsDispatched(true);
  }, [dispatch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true); // Add 'sticky' class when scroll > 56px
      } else {
        setIsSticky(false); // Remove 'sticky' class
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Define the second table data with colors
  const secondTableData = [
    { label: "Total MoM", color: "blue" },
    { label: "Opened MoM", color: "#ff4500" },
    { label: "Completed MoM", color: "#71BC78" },
    { label: "Reopened MoM", color: "#f9b94b" },
    { label: "Closed MoM", color: "#009000" },
  ];

  // Prepare chart data (without filtering)
  const MoMchart = {
    labels: secondTableData.map((item) => item.label),
    datasets: [
      {
        data: (() => {
          const {totalMom, openMom, closedMom, completedMom, reopenedMom} = dashboardData?.momStatus ?? {}
          const ordered = [totalMom, openMom, completedMom, reopenedMom, closedMom]
          return ordered.filter(Boolean)
        })(),
        backgroundColor: secondTableData.map((item) => item.color),
        hoverBackgroundColor: secondTableData.map((item) => item.color),
      },
    ],
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
    },
  };

  // Define the second table data with colors
  const visitsTableData = [
    { label: "Total Dealers", color: "blue" },
    { label: "Pending Visit Plans", color: "#ff4500" },
    { label: "Visits Pending", color: "#f9b94b" },
    { label: "Visits Completed", color: "#009000" },
  ];

  // Prepare chart data (without filtering)
  const visitsChart = {
    labels: visitsTableData.map((item) => item.label),
    datasets: [
      {
        data: (() => {
          const { totalDealers, pendingVisitPlans, visitsPending, visitsCompleted } = dashboardData?.visitStatus ?? {}
          const ordered = [totalDealers, pendingVisitPlans, visitsPending, visitsCompleted]
          return ordered.map(elem => elem || 0)
        })(),
        backgroundColor: visitsTableData.map((item) => item.color),
        hoverBackgroundColor: visitsTableData.map((item) => item.color),
      },
    ],
    options: {
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
    },
  };

  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev, // Keep previous values
      [filterKey]: value, // Update the specific field
    }));
  };

  const getDashboardData = async () => {
    try {
      setLoader(true);
      const payload = filtersValue;
      const res = await GetDashboardData({ payload: payload });
      if (res.success) {
        setDashboardData(res.data);
      }
    } catch (error) {
      console.log("error: ", error);
      toast.error("Network error");
    } finally {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  };

  const handleSearch = async () => {
    await getDashboardData();
  };

  useEffect(() => {
    if (isDispatched) {
      getDashboardData();
    }
  }, [resetTrigger, isDispatched]);
  
  // chart data start
  const MVRchart = {
    labels: [
      "Total AMD",
      // "Pending At AM",
      "Submitted By AM",
      "Accepted By AMD",
      "Reconsideration By AMD",
      "Pending At AM",
    ],
    datasets: [
      {
        data: (() => {
          const { total = 0, submittedByAm = 0, accepted = 0, reconsidered = 0, pending = 0 } =
          dashboardData?.mvrStatus || {};
          return [total, submittedByAm, accepted, reconsidered, pending];
        })(),
        backgroundColor: [
          Colors.total,
          // Colors.pending,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderColor: [
          Colors.total,
          // Colors.pending,
          Colors.submitted,
          Colors.accepted,
          Colors.reconsidertion,
          Colors.pending,
        ],
        borderWidth: 1,
      },
    ],
  };

  const QVRchart = {
    labels: [
      "Total AMD",
      "Eligible AMD",
      "Visit Plan",
      "Evaluation By AM",
      "Reconsideration Request",
      "Accepted By AMD",
      "Avrage Score",
    ],
    datasets: [
      {
        data: [6, 1, 1, 1, 1, 1, 1],
        backgroundColor: [
          Colors.total,
          Colors.submitted,
          Colors.pending,
          Colors.total,
          Colors.reconsidertion,
          Colors.accepted,
          Colors.pending,
        ],
        borderColor: [
          Colors.total,
          Colors.submitted,
          Colors.pending,
          Colors.total,
          Colors.reconsidertion,
          Colors.accepted,
          Colors.pending,
        ],
        borderWidth: 1,
      },
    ],
  };
  // chart data end

  const handleReset = () => {
    dispatch(resetFilter());
    setResetTrigger(Date.now());
    setTimeout(() => setResetTrigger(false), 0);
  };

  return (
    <>
      <TabsContain>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs example"
          className={`HomeTabs ${isSticky ? "StickyShadow" : ""}`}
        >
          <Tab label="MVR" value="MVRTabs" />
          {/* <Tab label="QVR" value="QVRTabs" /> */}
        </Tabs>
      </TabsContain>

      {isPopupModalOpen && <PopUpModal onClose={closePopupModal} data={popUpData}/>}
          <ToastContainer position="top-right" autoClose={5000} />
      {value === "MVRTabs" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  onFilterChange={handleFilterChange}
                  reset={resetTrigger}
                ></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button onClick={handleSearch} className="SearchButton">
                      Search
                    </button>
                    <button onClick={handleReset} className="ResetButton">
                      Reset
                    </button>
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain mt={2}>
            <CardTitle variant="h4">MVR Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total AMD :
                      <span className="StatusCount total">
                        {dashboardData?.mvrStatus?.total}
                      </span>
                    </li>
                    {/* <li>
                      Pending At AM :
                      <span className="StatusCount pending">
                        {dashboardData?.mvrStatus?.submittedByAmd}
                      </span>
                    </li> */}
                    <li>
                      Submitted By AM :
                      <span className="StatusCount submitted">
                        {dashboardData?.mvrStatus?.submittedByAm}
                      </span>
                    </li>
                    <li>
                      Accepted By AMD :
                      <span className="StatusCount accepted">
                        {dashboardData?.mvrStatus?.accepted}
                      </span>
                    </li>
                    <li>
                      Reconsideration By AMD :
                      <span className="StatusCount reconsidertion">
                        {dashboardData?.mvrStatus?.reconsidered}
                      </span>
                    </li>
                    <li>
                      Pending At AM :
                      <span className="StatusCount pending">
                        {dashboardData?.mvrStatus?.pending}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={MVRchart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooter>
              <div>
                <p>
                  {" "}
                  Total MVR Submitted :{" "}
                  <span className="MVRCount">
                    {dashboardData?.mvrStatus?.totalSubmitted}
                  </span>
                </p>
              </div>

              <CustomButtonContain>
                <Link to="/amdstatus">
                  <button className="Pointer">
                    AMD Wise Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>

          {/* Second Table */}

          <CardContain mt={2}>
            <CardTitle variant="h4">MoM Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total MoM :
                      <span className="StatusCount" style={{ color: "blue" }}>
                        {dashboardData?.momStatus?.totalMom}
                      </span>
                    </li>
                    <li>
                      Opened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {dashboardData?.momStatus?.openMom}
                      </span>
                    </li>
                    <li>
                      Completed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#71BC78" }}
                      >
                        {dashboardData?.momStatus?.completedMom}
                      </span>
                    </li>
                    <li>
                      Reopened MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {dashboardData?.momStatus?.reopenedMom}
                      </span>
                    </li>
                    <li>
                      Closed MoM :
                      <span
                        className="StatusCount"
                        style={{ color: "#009000" }}
                      >
                        {dashboardData?.momStatus?.closedMom}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={MoMchart} />
                </Grid>
              </Grid>
            </Card>
            <CardFooterMoM>
              <CustomButtonContainMoM>
                <Link to="/momstatus">
                  <button className="Pointer">
                    MoM Status <KeyboardDoubleArrowRightIcon />
                  </button>
                </Link>
              </CustomButtonContainMoM>
            </CardFooterMoM>
          </CardContain>

          {/* Third Table */}

          <CardContain mt={2}>
            <CardTitle variant="h4">Visit Status</CardTitle>
            <Card>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardCustomList>
                    <li>
                      Total Dealers :
                      <span className="StatusCount" style={{ color: "blue" }}>
                        {dashboardData?.visitStatus?.totalDealers ?? ""}
                      </span>
                    </li>
                    <li>
                      Pending Visit Plans :
                      <span
                        className="StatusCount"
                        style={{ color: "#ff4500" }}
                      >
                        {dashboardData?.visitStatus?.pendingVisitPlans ?? ""}
                      </span>
                    </li>
                    <li>
                     Visits Pending :
                      <span
                        className="StatusCount"
                        style={{ color: "#f9b94b" }}
                      >
                        {dashboardData?.visitStatus?.visitsPending ?? ""}
                      </span>
                    </li>
                    <li>
                    Visits Completed :
                      <span
                        className="StatusCount"
                        style={{ color: "#009000" }}
                      >
                        {dashboardData?.visitStatus?.visitsCompleted ?? ""}
                      </span>
                    </li>
                  </CardCustomList>
                </Grid>
                <Grid item xs={6}>
                  <DoughnutChart data={visitsChart} />
                </Grid>
              </Grid>
            </Card>

            <CardFooter>
              <div>
                <p>
                  Total Visits Planned :
                  <span className="MVRCount">
                    {dashboardData?.visitStatus?.visitsPlanned ?? ""}
                  </span>
                </p>
              </div>

              <CustomButtonContain>
              </CustomButtonContain>
            </CardFooter>
          </CardContain>
        </>
      )}

      {loader && <Loader fullScreen={true} />}
    </>
  );
}

export default Home;
